import React from 'react';
import Link from 'next/link';
import { usePathname, useSearchParams } from 'next/navigation';
import { useRouter } from 'next/navigation';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import { useAtom, useAtomValue } from 'jotai';
import { cn } from '@/lib/utils';
import {
  prevChapterAtom,
  nextChapterAtom,
} from '../../jotaiStore/chaptersStore';
import {
  mapDataAtom,
  isEitherStreamingAtom,
  viewportAtom,
  isLoadingNavAtom,
  contentAtom,
  pass2LearningPathAtom,
} from '../../jotaiStore';
import { slugify } from '../../lib/map/slugify';
import { showNavigationWarningToast } from '@/lib/toast';

const getItemTitle = (
  topic: any,
  type: 'section' | 'option' | 'sidequest',
  index: number
): string => {
  if (type === 'section') return topic?.sections?.[index]?.subTopicTitle || '';
  if (type === 'option') return topic?.options?.[index]?.optionTitle || '';
  return topic?.sideQuests?.[index]?.sideQuestTitle || '';
};

const BottomNavigation = ({ showDesktopSidebar, setIsNavLoading }) => {
  // const [, setIsNavLoading] = useAtom(isLoadingNavAtom);
  const pathName = usePathname();
  const mapData = useAtomValue(mapDataAtom);
    const pass2LearningPath = useAtomValue(pass2LearningPathAtom);
  const [, setContentText] = useAtom(contentAtom);
  const viewport = useAtomValue(viewportAtom);

  let lastSlashIndex;
  let trimmedPathName;
  let subTopicSlug;
  if (pathName) {
    lastSlashIndex = pathName.lastIndexOf('/');
    trimmedPathName = pathName.substring(0, lastSlashIndex);
    subTopicSlug = pathName.substring(lastSlashIndex + 1);
  }

  const nextChapterData = useAtomValue(nextChapterAtom);
  console.log('nextChapterData', nextChapterData);
  const prevChapterData = useAtomValue(prevChapterAtom);
  console.log('prevChapterData', prevChapterData);
  const isStreaming = useAtomValue(isEitherStreamingAtom);

  if (!prevChapterData && !nextChapterData) {
    return null;
  }

  if (subTopicSlug === 'overview') {
    return null;
  }

  // replace prevChapterData with overview link
  let showOverviewLinkAsPrevLink = false;
  if (subTopicSlug !== 'overview' && !prevChapterData && nextChapterData) {
    showOverviewLinkAsPrevLink = true;
  }

  const getNavigationData = (chapterData: any) => {
    if (!chapterData || (!mapData && !pass2LearningPath)) return null;

    if (chapterData.type === 'whats-next') {
      return {
        title: "What's Next",
        slug: 'whats-next',
      };
    } else {
      const topic = mapData?.topicList[chapterData.topicIndex] || pass2LearningPath?.[chapterData.topicIndex]
      const title = getItemTitle(
        topic,
        chapterData.type,
        chapterData.subtopicIndex
      );
      const slug = slugify(title);

      return {
        title,
        slug,
      };
    }
  };
    console.log("🚀 ~ getNavigationData ~ mapData:", mapData)

  const prevData = prevChapterData ? getNavigationData(prevChapterData) : null;
  
  console.log("🚀 ~ BottomNavigation ~ nextChapterData:", nextChapterData)
  const nextData = nextChapterData ? getNavigationData(nextChapterData) : null;
  console.log("🚀 ~ BottomNavigation ~ nextData:", nextData)

  const getLinkUrl = (slug: string) => {
    return `${trimmedPathName}/${slug}?x=${viewport.x}&y=${viewport.y}&zoom=${viewport.zoom}`;
  };

  return (
    <>
      <div
        className={cn(
          `fixed sm:sticky text-shades-text transition-all duration-300 bottom-0 left-0 bg-shades-baseDark border-t-[1px] border-shades-surfaceDark flex justify-between min-w-full pb-3 pt-3 px-2 sm:px-3 text-sm sm:text-base`
        )}
      >
        {showOverviewLinkAsPrevLink && (
          <Link
            href={`${trimmedPathName}?x=${viewport.x}&y=${viewport.y}&zoom=${viewport.zoom}`}
            className={cn(
              'relative cursor-pointer flex group transition-all duration-200'
            )}
            onClick={(e) => {
              if (isStreaming) {
                e.preventDefault();
                showNavigationWarningToast();
              } else {
                setIsNavLoading(true);
                setContentText('');
              }
            }}
          >
            <ChevronLeftIcon
              className="h-6 w-6 group-hover:text-colors-green "
              aria-hidden="true"
            />
            <span className="group-hover:text-colors-green underline mt-[2px] ml-[2px] sm:mt-0 sm:ml-0">
              Overview
            </span>
          </Link>
        )}

        {prevData && (
          <Link
            href={getLinkUrl(prevData.slug)}
            className={cn(
              'relative cursor-pointer flex group transition-all duration-200 text-shades-text'
            )}
            onClick={(e) => {
              if (isStreaming) {
                e.preventDefault();
                showNavigationWarningToast();
              } else {
                setIsNavLoading(true);
                setContentText('');
              }
            }}
          >
            <ChevronLeftIcon
              className="h-6 w-6 group-hover:text-colors-green "
              aria-hidden="true"
            />
            <span className="group-hover:text-colors-green underline mt-[2px] ml-[2px] sm:mt-0 sm:ml-0">
              {prevData.title}
            </span>
          </Link>
        )}

        {nextData && (
          <Link
            href={getLinkUrl(nextData.slug)}
            className="flex group cursor-pointer hover:text-colors-green text-right text-shades-text"
            onClick={(e) => {
              if (isStreaming) {
                e.preventDefault();
                showNavigationWarningToast();
              } else {
                setIsNavLoading(true);
                setContentText('');
              }
            }}
          >
            <span className="group-hover:text-colors-green underline mt-[1px] mr-[2px] sm:mt-0 sm:mr-0">
              {nextData.title}
            </span>
            <ChevronRightIcon
              className="h-6 w-6  group-hover:text-colors-green "
              aria-hidden="true"
            />
          </Link>
        )}
      </div>
    </>
  );
};

export default BottomNavigation;
